import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getAccountService } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchAccountServices(): Promise<APIResult> {
  const response = await fetch(getAccountService, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  Data: Array<{
    Id: number;
    Description: string;
  }>;
  IsSucess: boolean;
  StatusCode: number;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetAccountServices(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_account_services',
    async () => {
      const fetchResponse = await fetchAccountServices();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: item.Description,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetAccountServices };
